<template>
    <div class="wrapper">
        <div v-if="showBack">
            <a @click="getReset()" href="#" class="back-btn">
                <img src="../assets/back.png" width="15" height="15"
                     alt="back"></a>
            <div v-if="canDisplayLeftArrow">
                <a class="nav-btn nav-btn-left nav-btn-left-back" href="#"
                   @click="moveLeft">
                    &#171;</a>
            </div>
        </div>
        <div v-else>
            <div v-if="canDisplayLeftArrow">
                <a class="nav-btn nav-btn-left " href="#" @click="moveLeft">
                    &#171;</a>
            </div>
        </div>
        <div class="letters-container" ref="lettersContainer">
            <v-touch @pan="onPan">
                <div class="letters" :style="{marginLeft: marginLeft+'px'}" ref="letters" :key="1">
                    <a href="javascript:void(0)"
                       v-for="(letter, index) in letters"
                       :key="letter"
                       :el="letter"
                       @click="getActiveLetter(letter,$event)"
                       :class="{'active':currentIndex === index, 'first': index === 0, 'last' : index === 26, 'disable': !exists(letter) }">
                        {{letter}}
                    </a>
                </div>
            </v-touch>
        </div>
        <div v-if="canDisplayRightArrow">
            <a class="nav-btn nav-btn-right" href="#"
               @click="moveRight">&#187;</a>
        </div>
    </div>
</template>
<script>
    export default {
        name: "LetterNavigation",
        props: {
            dict: {
                type: Array,
                required: true
            },
            currentActiveLetter: {
                type: String,
                required: true
            },
            showBack: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ#".split(""),
                currentIndex: 0,
                divCenterX: 0,
                marginLeft: 0,
                fontSize: 1,
                currentLettersPosition: 0,
                moveStepSize: 4,
                letterSize: 0,
                lastLetter: 0,
                first: null,
                last: null,
                canDisplayLeftArrow: false,
                canDisplayRightArrow: true,
            }
        },
        mounted: function () {
            this.letterLength = this.letters.length - 1;
            this.calculations();
            let that = this;
            $(window).resize(function () {
                that.calculations();
            });
            // this.first = this.$el.querySelector(".first");
            // this.last = this.$el.querySelector(".last");

        },
        methods: {
            getReset: function () {
                this.$emit("getResetFromLetterNavigation", true);
            },
            getActiveLetter: function (letter, e) {
                if(letter > this.currentActiveLetter){
                    this.$emit("setSlidingRightState", true);
                }else{
                    this.$emit("setSlidingRightState", false);
                }
                this.$emit("setCurrentActiveLetter", letter);
                this.currentIndex = this.letters.indexOf(letter);
                let firstTerms = this.firstTerms();
                // this.marginLeft += (this.divCenterX) - (e.target.offsetLeft + e.target.offsetWidth / 2);
                if (!(firstTerms[letter] === undefined)) {
                    this.$emit('getcurrentSelectedIdxFromFirstTerms', firstTerms[letter]);
                    this.$emit("currentActiveLetterClick", firstTerms[letter]);
                }
            },
            /*
              *
              * assuming the list is sorted
              * input: dictionary object
              * output: a map of the letter with the index of the first occurrence of that letter
              * i.e { 'A': 0, 'B': 3, 'C': 12}
              *
              * */
            firstTerms: function () {
                let firstTermsObj = {};
                for (let i = 0; i < this.dict.length; i++) {
                    if (this.dict[i].term === "*") continue;
                    let letter = this.isLetter(this.dict[i].term[0]);
                    let char = '';
                    if (letter !== "*") {
                        char = letter ? this.dict[i].term[0] : "#";
                    }
                    if (!(char in firstTermsObj)) {
                        firstTermsObj[char] = i;
                    }
                }
                return firstTermsObj;
            },
            moveLeft: function () {
                let nextStep = this.currentIndex - this.moveStepSize;
                let $letterA = $('.letters a');

                if (nextStep > 0) {
                    for (let i = nextStep; $letterA[nextStep].classList.contains('disable'); i--) {
                        nextStep = i;
                    }
                }

                let nextLetter = null;

                if (nextStep < 0) {
                    nextLetter = $letterA[0];
                } else {
                    nextLetter = $letterA[nextStep];
                }
                nextLetter.click();
            },
            moveRight: function () {
                let nextStep = this.currentIndex + this.moveStepSize;
                let $letterA = $('.letters a');

                if (nextStep < this.letterLength) {
                    for (let i = nextStep; $letterA[nextStep].classList.contains('disable'); i++) {
                        nextStep = i;
                    }
                }

                let nextLetter = null;

                if (nextStep > this.letterLength) {
                    nextLetter = $letterA[this.letterLength];
                } else {
                    nextLetter = $letterA[nextStep];
                }
                nextLetter.click();
            },
            isLetter: function (str) {
                return str.length === 1 && str.match(/[a-z]/i);
            },
            exists: function (letter) {
                let firstTerms = this.firstTerms();
                let knownLetters = [];
                for (let key in firstTerms) knownLetters.push(key);
                return knownLetters.includes(letter);
            },
            onPan: function (e) {
                this.marginLeft += e.velocity * 100;
            },
            calculations: function () {
                let lettersOffset = this.$refs.letters.offsetLeft || 0; // $(".letters").offset().left; // this.$refs.letters.offsetLeft;
                // console.log($(".letters").offset().left);
                // console.log(this.$refs.letters.offsetLeft);
                let letterActiveOffset = this.$refs.letters.childNodes[this.currentIndex].offsetLeft;
                this.divCenterX = this.$refs.lettersContainer.offsetWidth / 2;
                // console.log("lettersOffset", lettersOffset);
                // console.log("letterActiveOffset", letterActiveOffset);
                // console.log("this.divCenterX", this.divCenterX);
                // If not first letter then do a bit more offsetting

                if (lettersOffset !== letterActiveOffset) {
                    this.marginLeft = this.divCenterX - (letterActiveOffset - lettersOffset);
                } else {
                    this.marginLeft = this.divCenterX;
                }
            },
        },
        watch: {
            currentActiveLetter: function (newVal) {
                let letter = this.isLetter(newVal);
                this.currentIndex = this.letters.indexOf(letter ? newVal : "#");
                this.marginLeft += ((this.divCenterX) - (this.$refs.letters.childNodes[this.currentIndex].offsetLeft + this.$refs
                    .letters.childNodes[this.currentIndex].offsetWidth / 2));
            },
            currentIndex: function () {
                if (this.letters[this.currentIndex] !== "A") {
                    this.canDisplayLeftArrow = true;
                }
                if (this.letters[this.currentIndex] === "A") {
                    this.canDisplayLeftArrow = false;
                }
                if (this.letters[this.currentIndex] === "#") {
                    this.canDisplayRightArrow = false;
                }
                if (this.letters[this.currentIndex] !== "#") {
                    this.canDisplayRightArrow = true;
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    .wrapper {
        position: relative;
        height: auto;
        z-index: 100;
    }

    .letters-container {
        position: relative;
        height: auto;
        width: 65%;
        margin: 0 auto;
        overflow: hidden; // background: yellow;
    }

    .letters {
        font-family: "Frutiger LT W01_65 Bold1475746", 'Avenir', Helvetica, Arial, sans-serif;
        height: 62px;
        padding-top: 3px;
        line-height: 62px;
        text-align: left;
        white-space: nowrap;
        a:not(:first-child) {
            opacity: 0.5;
            color: grey;
        }
        .first {
            opacity: 0.5;
            color: grey;
        }
        a.active {
            color: #D40511;
            opacity: 1;
        }
        @media(hover){
            a:hover {
                color: #D40511;
                opacity: 1;

            }
        }

    }

    .disable {
        pointer-events: none;
        cursor: default;
        opacity: 0.1 !important;
    }

    .nav-btn {
        font-size: 32px;
        color: #D40511;
        transform: translateY(-50%);
    }

    .nav-btn-left {
        position: absolute;
        top: 50%;
        width: 0;
        @media screen and (min-width: 320px) {
            left: 4rem;
        }
        @media screen and (min-width: 768px) {
            left: 10%;
            width: 0;
        }
    }

    .nav-btn-left-back {
        @media screen and (min-width: 320px) {
            left: 4rem !important;
        }
        @media screen and (min-width: 768px) {
            left: 4rem !important;
        }
    }

    .nav-btn-right {
        position: absolute;
        top: 50%;
        @media screen and (min-width: 320px) {
            right: 3%;
        }
        @media screen and (min-width: 768px) {
            right: 0;
        }
    }

    .list-enter-active,
    .list-leave-active {
        transition: all 1s;
    }

    .list-enter,
    .list-leave-to
        /* .list-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .letters {
        /*transform : translateX(' ')*/
        transition: margin-left 0.25s;
    }

    .back-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        @media only screen and (min-width: 480px) {
            left: 0;
        }
        @media only screen and (min-width: 780px) {
            left: -10%;
        }
    }

    /* Extra Small Devices, Phones */
    @media only screen and (min-width: 320px) {
        a {
            text-decoration: none;
            width: 43px;
            text-align: center;
            display: inline-block;
        }
    }

    @media only screen and (min-width: 480px) {

    }

    /* Small Devices, Tablets */
    @media only screen and (min-width: 1024px) {
        a {
            width: 60px;
        }
    }
    /* Large Devices, Wide Screens */
    @media only screen and (min-width: 1200px) {
        a {
            width: 60px;
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/LetterNavigation.vue